import React from 'react';

import bseLogo from "images/bse-logo.png";
import styled from 'styled-components';
import { Row, Col } from 'antd';
import { useMediaQuery } from 'react-responsive';

const BseInformationContainer = styled.div`
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 10px;
`;

const BseInformation: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return <BseInformationContainer>
        <Row gutter={ 0 } style={ { justifyContent: isMobile ? 'center' : 'flex-start' } }>
            <Col xs={ 4 } md={ 2 }>
                <img alt={ 'bse-logo' } style={ { height: "45px", marginTop: isMobile ? '10px' : '0' } } src={ bseLogo } />
            </Col>
            <Col xs={ 18 } style={{marginLeft: isMobile ? '10px': ''}}>
                <div>
                    <p style={ { fontSize: "13px", fontWeight: "bold" } }>100% secure payments and BSE approved</p>
                    <p style={ { fontSize: "11px", margin: "0 0 10px" } }>Turtlemint Money is BSE approved and your payment<br />is 100% secure.</p>
                </div>

            </Col>
        </Row>

    </BseInformationContainer >
}

export default BseInformation;